import Category from '../components/Category/Category';
import classes from './screen.module.css';
const CategoryScreen = () => {
	return (
		<div className={classes.category}>
			<Category />
		</div>
	);
};

export default CategoryScreen;
